<nb-layout #nbLayout (mousemove)="onResizing($event)">
  <nb-layout-column class="p-0 bg-white">
    <div class="d-flex vh-100">
      <p-progress-bar
        class="position-fixed top-0 left-0 vw-100"
        [style.height]="'0.25rem'"
        [style.z-index]="999"
        mode="indeterminate"
        [hidden]="!showGlobalProgressBar()"
      />

      <div
        class="h-100 bg-white align-items-center flex-column p-4 border-right border-color-muted gap-4 position-relative"
        mwlResizable
        [style.display]="(showSideBar$ | async) ? 'flex' : 'none'"
        [style.flex-basis]="currentSidebarWidth + 'px'"
        [style.width]="currentSidebarWidth + 'px'"
        [enableGhostResize]="true"
        [allowNegativeResizes]="false"
        (resizeStart)="onResizeStart($event)"
        (resizeEnd)="onResizeEnd($event)"
        [validateResize]="validate"
      >
        <div
          class="pull-open"
          mwlResizeHandle
          [resizeEdges]="{ right: true }"
          hidden
        ></div>
        <img
          ngSrc="/assets/images/helix_1.png"
          alt="HELIX"
          width="180"
          height="124"
          priority="1"
        />
        <ngx-asset-tree-sidebar
          class="w-100 flex-grow-1 pb-2 overflow-auto"
          [hidden]="(showSideBar$ | async) !== true"
        />
      </div>

      <div
        [style.width]="'calc(100vw - ' + currentSidebarWidth + 'px)'"
        [style.margin-top]="'5.5rem'"
        [style.margin-bottom]="'7rem'"
        class="mx-3 d-flex flex-column"
      >
        <ngx-header
          class="p-2 position-fixed d-flex top-0 bg-white border-bottom border-1 border-color-muted"
          [style.width]="'calc(100vw - ' + currentSidebarWidth + 'px - 2rem)'"
          [style.height]="'4.5rem'"
        ></ngx-header>

        @if (authService.isAuthenticated() | async) {
          <ngx-top-status-bar></ngx-top-status-bar>
        }
        <div class="h-100 overflow-y-auto">
          <router-outlet></router-outlet>
        </div>

        <ngx-time-selector
          class="position-fixed bottom-0 bg-white p-2 border-color-muted border-top"
          [style.width]="'calc(100vw - ' + currentSidebarWidth + 'px - 2rem)'"
        ></ngx-time-selector>
      </div>
    </div>
  </nb-layout-column>
</nb-layout>
